import { LandscapeBuyerRelationType } from '../../../landscapeAPI/landscape/landscape-buyer-relation-type';
import { BaseTradeService } from '../../base-trade.service';
import { CommoditySaveRequestDto } from '../dto/request/commodity-save-request.dto';
import { CommodityUpdateRequestDto } from '../dto/request/commodity-update-request.dto';
import { CommodityResponseDto } from '../dto/response/commodity-response.dto';
import { NonRecursiveCommodityResponseDto } from '../dto/response/non-recursive-commodity-response.dto';
import { SourcedCommoditiesResponseDto } from '../dto/response/sourced-commodities-response.dto';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class CommodityService extends BaseTradeService {
  public async fetchCommodities(): Promise<CommodityResponseDto[]> {
    const response = await this.get<CommodityResponseDto[]>(`/commodity`);
    return response.data;
  }

  public async fetchCommoditiesNonRecursive(): Promise<
    NonRecursiveCommodityResponseDto[]
  > {
    const response = await this.get<NonRecursiveCommodityResponseDto[]>(
      `/commodity/nonrecursive`
    );
    return response.data;
  }

  public async fetchSourcedCommoditiesByBuyerId(
    buyerId: string | null = null,
    relationType: LandscapeBuyerRelationType | null = null
  ): Promise<SourcedCommoditiesResponseDto[]> {
    const response = await this.get<SourcedCommoditiesResponseDto[]>(
      `/commodity/getsourcedcommoditiesbybuyerid`,
      {
        params: {
          buyerId,
          relationType,
        },
      }
    );
    return response.data;
  }

  public async fetchCommodityById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<NonRecursiveCommodityResponseDto> {
    const response = await this.get<NonRecursiveCommodityResponseDto>(
      `/commodity/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async saveCommodity(
    saveRequest: CommoditySaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<CommodityResponseDto> {
    const response = await this.post<CommodityResponseDto>(
      `/commodity`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateCommodity(
    updateRequest: CommodityUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<CommodityResponseDto> {
    const response = await this.put<CommodityResponseDto>(
      `/commodity`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteCommodity(id: string): Promise<void> {
    await this.delete<void>(`/commodity/${id}`);
  }
}

const commodityService = new CommodityService();
export default commodityService;
